module.exports = __webpack_public_path__ + "img/corp-mob-1.a29bb9b4.svg";